import * as React from 'react'
import { NavLink, Link } from 'react-router-dom'
import ERoute from '../../ERoute'
import Avatar from '../Avatar/Avatar'
import { SessionController } from '../../controllers'
import { CSSTransition } from 'react-transition-group'
import { AppState } from '../../store'
import { connect } from 'react-redux'
import Icon from '../Icons/Icon'
import styled, { css } from 'styled-components'
import { Style } from '../../styles'
import FlyoutDivider from '../Flyout/FlyoutDivider'
import FlyoutHeaderAccount from '../Flyout/FlyoutHeaderAccount'
import FlyoutHeaderAccountAvatar from '../Flyout/FlyoutHeaderAccountAvatar'
import FlyoutHeaderAccountTitle from '../Flyout/FlyoutHeaderAccountTitle'
import FlyoutHeaderAccountDescription from '../Flyout/FlyoutHeaderAccountDescription'
import ProjectHelper from '../../helpers/ProjectHelper'
import { showMobileAppModal } from '../../store/modals/actions'
import { AnyAction, Dispatch } from 'redux'
import { WithTranslation, withTranslation } from 'react-i18next'
import UserWorkspaceSettingHelper from '../../helpers/UserWorkspaceSettingHelper'
import NavigationHelper from '../../helpers/NavigationHelper'
import DroppableHelper from '../../helpers/DroppableHelper'
import { closeNavigation } from '../../store/navigation/actions'
import SidebarNavigationItemDropdownIndicator from './SidebarNavigationItemDropdownIndicator'
import sidebarNavigationItemStyles from './sidebarNavigationItemStyles'
import SidebarNavigationItem from './SidebarNavigationItem'
import SidebarNavigationSubItems from './SidebarNavigationSubItems'
import SidebarGroupNavigationItem from './SidebarGroupNavigationItem'
import SidebarNavigationItemLink from './SidebarNavigationItemLink'
import { CurrentUser, NavigationMenuItemPage, NavigationMenuItemType, ProjectStatus, UserWorkspaceSettingRole, UserWorkspaceSettingScope } from '../../types'
import SidebarCalendar from './SidebarCalendar'
import SidebarContacts from './SidebarContact'
import SidebarTask from './SidebarTask'
import Images from '../../images'
import ChatWidgetHelper from '../../helpers/ChatWidgetHelper'
import SidebarNavigationFlyout from './SidebarNavigationFlyout'

const SidebarNavigation = styled.div<{ active?: boolean }>`
  display: flex;
  position: fixed;
  left: 0px;
  z-index: 16;
  height: auto;
  bottom: 0px;
  top: 0px;
	background: #181818;
  flex-direction: column;
  width: 250px;

  .has-banner & {
    top: 40px;

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      top: 0px;
    }
  }

	@media screen and (max-width: ${Style.breakpoints.SMALL}) {
    top: 0px;
		left: -200vw;
    width: 100%;

    ${props => props.active && css`
      left: 0px;
    `}
	}
`

const SidebarContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex: 1 1;
	overflow-y: auto;

	&::-webkit-scrollbar {
    background: #000;
		height: 8px;
		width: 6px;
	}

	&::-webkit-scrollbar-thumb {
    border: 1px solid #000;
    background-color: #737373;
    border-radius: 4px;
	}
`


const SidebarNavigationGroup = styled.div`
  display: flex;
  flex-direction: column;
`

const SidebarHeader = styled.div`
  position: relative;
	display: flex;
	align-items: center;
	background-color: black;
	position: relative;
`

const SidebarHeaderWrapper = styled.div`
	display: flex;
	padding: 20px;
	transition: background ${Style.animations.baseTransitionSpeed} ease-in-out;
	width: 100%;
	flex-direction: column;
`

const SidebarCloseButton = styled.div`
  position: absolute;
  top: ${Style.spacing.x1};
  right: ${Style.spacing.x1};
	cursor: pointer;
  color: '#FFFFF';
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  display: none;
  
  i {
    font-size: 25px;
    color: #FFFFFF;
  }

  svg {
    fill: #FFFFFF;
  }

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: flex;
  }
`

const SidebarWorkspaceName = styled.div`
	margin-bottom: 0;
	color: #fff;
	font-weight: 700;
	font-size: 20px;
	text-overflow: ellipsis;
	overflow: hidden;
	flex: 0 1 auto;
  white-space: nowrap;
  width: 100%;


	a {
		color: white;

		&:hover {
			text-decoration: underline;
		}
	}

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    padding-right: 23px;
  }
`

const SidebarUsername = styled.div`
	color: #b3b3b3;
	font-size: 16px;
	font-weight: 600;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	a {
		color: #b3b3b3;

		&:hover {
			text-decoration: underline;
		}
	}
`

const SidebarNavigationItemDiv = styled.div`${sidebarNavigationItemStyles}`

const SidebarNavigationSubItem = styled(NavLink)`
	${sidebarNavigationItemStyles}
	padding-left: 56px;
	padding-right: 10px;
	font-size: 14px;
	font-weight: 500;

	&.is-active {
		color: white;
		font-weight: 600;
	}
`

const SidebarNavigationItemDivider = styled.hr`
  margin: 0;
  height: 1px;
  background: black;
  border: none;
  width: 100%;
  margin: 8px 0;
`

const SidebarNavigationFlyoutWithReferral = styled.div`
  position: fixed;
  opacity: 0;
  left: 240px;
  bottom: ${Style.spacing.x1};
  z-index: 100;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #eff3f5;
  display: block;
  box-shadow: 0 2px 8px 1px #d6dde1;
  width: 268px;
  max-width: 268px;
  transition: all ${Style.animations.baseTransitionSpeed} ease-in-out;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    left: 50%;
    transform: translateX(-50%);
    box-shadow: none;
  }

  &.is-notification {
    min-width: 320px;
    max-width: 320px;
  }

  &.is-appear, &.is-appear-active {
    opacity: 0;
    left: 0;

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      left: 50%;
      transform: translateX(-50%);
    }
  }

	&.is-entering-active {
    opacity: 1;
    left: 258px;

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      left: 50%;
      transform: translateX(-50%);
      bottom: 1
    }
	}

	&.is-leaving {
    opacity: 0;
    left: 240px;
    pointer-events: none;

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      left: 50%;
      transform: translateX(-50%);
    }
	}

  display: flex;
  flex-direction: row;
  max-width: initial;
  width: initial;
`

const Flyout = styled.div`
`

const AccountFlyout = styled(Flyout)`
  display: flex;
  flex-direction: column;
`


const FlyoutReferral = styled(Flyout)`
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${Style.color.border};
  max-width: 340px;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: none;
  } 
`

const FlyoutReferralHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid ${Style.color.border};
  font-weight: 500;
  text-align: center;
`
const FlyoutReferralContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 18px;
  letter-spacing: -0.25px;
  font-weight: 400;

  img {
    height: 205px;
  }

  p {
    margin-bottom: 16px;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-end;
  }
`

const FlyoutReferralAction = styled(NavLink)`
  color: white;
  text-decoration: none;
  padding: 12px 35px;
  font-weight: 600;
  white-space: nowrap;
  border-radius: 100px;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${Style.color.brandPrimary};
  width: 100%;
`


interface IStateToProps {
  currentUser: CurrentUser
  navigationActive: boolean
}
interface IDispatchToProps {
  showMobileAppModal: typeof showMobileAppModal
  closeNavigation: typeof closeNavigation
}

type IProps = IStateToProps & IDispatchToProps & WithTranslation

interface IState {
  calendarFlyoutActive: boolean
  accountFlyoutActive: boolean
  taskFlyoutActive: boolean
  contactFlyoutActive: boolean
}

const DEFAULT_STATE: IState = {
  calendarFlyoutActive: false,
  taskFlyoutActive: false,
  contactFlyoutActive: false,
  accountFlyoutActive: false,
}

class MainNavigation extends React.Component<IProps, IState> {
  private accountFlyoutToggle = React.createRef<HTMLDivElement>()
  private accountFlyoutContainer = React.createRef<HTMLDivElement>()

  constructor(props: IProps) {
    super(props)

    this.state = DEFAULT_STATE

    this.onChatClick = this.onChatClick.bind(this)
    this.onToggleAccountFlyout = this.onToggleAccountFlyout.bind(this)
    this.onDismissAccountFlyout = this.onDismissAccountFlyout.bind(this)
    this.onLogoutClick = this.onLogoutClick.bind(this)
    this.onMobileAppClick = this.onMobileAppClick.bind(this)
    this.onCompanyInfoClick = this.onCompanyInfoClick.bind(this)
    this.closeMobileNavigation = this.closeMobileNavigation.bind(this)
    this.onCalendarFlyoutActivatorClick = this.onCalendarFlyoutActivatorClick.bind(this)
    this.onCalendarFlyoutActivatorEnter = this.onCalendarFlyoutActivatorEnter.bind(this)
    this.onCalendarFlyoutActiveChange = this.onCalendarFlyoutActiveChange.bind(this)
    this.onCalendarFlyoutClose = this.onCalendarFlyoutClose.bind(this)
    this.onTaskFlyoutActivatorClick = this.onTaskFlyoutActivatorClick.bind(this)
    this.onTaskFlyoutActivatorEnter = this.onTaskFlyoutActivatorEnter.bind(this)
    this.onTaskFlyoutActiveChange = this.onTaskFlyoutActiveChange.bind(this)
    this.onTaskFlyoutClose = this.onTaskFlyoutClose.bind(this)
    this.onContactFlyoutActivatorClick = this.onContactFlyoutActivatorClick.bind(this)
    this.onContactFlyoutActivatorEnter = this.onContactFlyoutActivatorEnter.bind(this)
    this.onContactFlyoutActiveChange = this.onContactFlyoutActiveChange.bind(this)
    this.onContactFlyoutClose = this.onContactFlyoutClose.bind(this)
  }

  componentDidMount(): void {
    document.addEventListener('click', this.handleClickOutside)
  }

  handleClickOutside = (event: MouseEvent) => {
    const { accountFlyoutActive } = this.state

    if (!accountFlyoutActive) return

    if (
      this.accountFlyoutToggle.current && !this.accountFlyoutToggle.current.contains(event.target as Node) &&
      this.accountFlyoutContainer.current && !this.accountFlyoutContainer.current.contains(event.target as Node)
    ) {
      this.onDismissAccountFlyout()
    }
  }

  onChatClick() {
    ChatWidgetHelper.openChat()
    this.closeMobileNavigation()
  }

  onToggleAccountFlyout() {
    const { accountFlyoutActive } = this.state

    this.setState({ accountFlyoutActive: !accountFlyoutActive })
  }

  onMobileAppClick() {
    const { showMobileAppModal } = this.props

    this.onDismissAccountFlyout()
    this.closeMobileNavigation()

    showMobileAppModal()
  }

  onDismissAccountFlyout() {
    this.setState({ accountFlyoutActive: false })
    this.closeMobileNavigation()
  }

  onCompanyInfoClick(e) {
    if (!UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)) {
      e.preventDefault()
      return
    }

    this.closeMobileNavigation()
  }

  onLogoutClick(e) {
    e.preventDefault()

    this.onDismissAccountFlyout()

    SessionController
      .logout()
      .then(() => {
        window.location.assign('/')
      })
      .catch(console.error)
  }

  closeMobileNavigation() {
    this.props.closeNavigation()
  }

  onCalendarFlyoutActivatorClick() {
    this.setState({ calendarFlyoutActive: false })
    this.closeMobileNavigation()
  }

  onCalendarFlyoutActivatorEnter() {
    this.setState({
      ...DEFAULT_STATE,
      calendarFlyoutActive: true
    })
  }

  onCalendarFlyoutActiveChange(active: boolean) {
    this.setState({ calendarFlyoutActive: active })
  }

  onCalendarFlyoutClose(e?) {
    this.setState({ calendarFlyoutActive: false })
  }

  onTaskFlyoutActivatorClick() {
    this.setState({ taskFlyoutActive: false })
    this.closeMobileNavigation()
  }

  onTaskFlyoutActivatorEnter() {
    this.setState({
      ...DEFAULT_STATE,
      taskFlyoutActive: true
    })
  }

  onTaskFlyoutActiveChange(active: boolean) {
    this.setState({ taskFlyoutActive: active })
  }

  onTaskFlyoutClose(e?) {
    this.setState({ taskFlyoutActive: false })
  }

  onContactFlyoutActivatorClick() {
    this.setState({ contactFlyoutActive: false })
    this.closeMobileNavigation()
  }

  onContactFlyoutActivatorEnter() {
    this.setState({
      ...DEFAULT_STATE,
      contactFlyoutActive: true
    })
  }

  onContactFlyoutActiveChange(active: boolean) {
    this.setState({ contactFlyoutActive: active })
  }

  onContactFlyoutClose(e?) {
    this.setState({ contactFlyoutActive: false })
  }

  render(): JSX.Element {
    const { calendarFlyoutActive, accountFlyoutActive, taskFlyoutActive, contactFlyoutActive } = this.state
    const { currentUser, navigationActive, t } = this.props
    const { setting } = currentUser.workspace

    return (
      <>
        <SidebarNavigation active={navigationActive}>
          <SidebarHeader>
            <SidebarHeaderWrapper>
              <SidebarWorkspaceName>
                <Link to={ERoute.PATH_SETTINGS_COMPANY_INFO} onClick={this.onCompanyInfoClick}>
                  {currentUser.workspace.business_name ? currentUser.workspace.business_name : '-'}
                </Link>
              </SidebarWorkspaceName>
              <SidebarUsername>
                <Link to={ERoute.PATH_ACCOUNT_PROFILE} onClick={this.closeMobileNavigation}>
                  {currentUser.name ? currentUser.name : currentUser.email}
                </Link>
              </SidebarUsername>
            </SidebarHeaderWrapper>

            <SidebarCloseButton onClick={this.closeMobileNavigation}>
              <Icon icon='close' />
            </SidebarCloseButton>
          </SidebarHeader>

          <SidebarContent>
            <SidebarNavigationGroup>
              {DroppableHelper.sort(setting.default_menu, 'ascending').map((navigationMenuItem, index) => {
                if (navigationMenuItem.type === NavigationMenuItemType.PAGE) {
                  let navigationItem = null
                  const navigationItemLabel = NavigationHelper.getNavigationItemPageLabel(navigationMenuItem.page)

                  switch (navigationMenuItem.page) {
                    case NavigationMenuItemPage.DASHBOARD:
                      navigationItem = <>
                        <SidebarNavigationItem to={ERoute.PATH_DASHBOARD} className='is-dashboard' activeClassName='is-active' exact onClick={this.closeMobileNavigation}>
                          <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g id="Integrations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="dashboard" fill="#FFFFFF">
                                <path d="M6.7,9.33333333 L1.36666667,9.33333333 C0.998666667,9.33333333 0.7,9.03466667 0.7,8.66666667 L0.7,0.666666667 C0.7,0.298666667 0.998666667,0 1.36666667,0 L6.7,0 C7.068,0 7.36666667,0.298666667 7.36666667,0.666666667 L7.36666667,8.66666667 C7.36666667,9.03466667 7.068,9.33333333 6.7,9.33333333 Z M14.7,5.33333333 L9.36666667,5.33333333 C8.99866667,5.33333333 8.7,5.03466667 8.7,4.66666667 L8.7,0.666666667 C8.7,0.298666667 8.99866667,-8.8817842e-16 9.36666667,-8.8817842e-16 L14.7,-8.8817842e-16 C15.068,-8.8817842e-16 15.3666667,0.298666667 15.3666667,0.666666667 L15.3666667,4.66666667 C15.3666667,5.03466667 15.068,5.33333333 14.7,5.33333333 Z" id="Shape" fillOpacity="0.6"></path>
                                <path d="M6.7,16 L1.36666667,16 C0.998666667,16 0.7,15.7013333 0.7,15.3333333 L0.7,11.3333333 C0.7,10.9653333 0.998666667,10.6666667 1.36666667,10.6666667 L6.7,10.6666667 C7.068,10.6666667 7.36666667,10.9653333 7.36666667,11.3333333 L7.36666667,15.3333333 C7.36666667,15.7013333 7.068,16 6.7,16 Z M14.7,16 L9.36666667,16 C8.99866667,16 8.7,15.7013333 8.7,15.3333333 L8.7,7.33333333 C8.7,6.96533333 8.99866667,6.66666667 9.36666667,6.66666667 L14.7,6.66666667 C15.068,6.66666667 15.3666667,6.96533333 15.3666667,7.33333333 L15.3666667,15.3333333 C15.3666667,15.7013333 15.068,16 14.7,16 Z" id="Shape"></path>
                              </g>
                            </g>
                          </svg>
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.CALENDAR:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.CALENDAR) && <SidebarNavigationFlyout
                        active={calendarFlyoutActive}
                        activator={
                          <SidebarNavigationItem
                            to={ERoute.PATH_CALENDAR}
                            activeClassName='is-active'
                          >
                            <Icon icon='calendar-day' />
                            <span>{navigationItemLabel}</span>
                          </SidebarNavigationItem>
                        }
                        onActivatorClick={this.onCalendarFlyoutActivatorClick}
                        onActivatorEnter={this.onCalendarFlyoutActivatorEnter}
                        onActiveChange={this.onCalendarFlyoutActiveChange}
                      >
                        <SidebarCalendar
                          active={calendarFlyoutActive}
                          onClose={this.onCalendarFlyoutClose}
                        />
                      </SidebarNavigationFlyout>
                      break
                    case NavigationMenuItemPage.TASKS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.TASK) && <SidebarNavigationFlyout
                        active={taskFlyoutActive}
                        activator={
                          <SidebarNavigationItem
                            to={ERoute.PATH_TASKS}
                            activeClassName='is-active'
                          >
                            <Icon icon='tasks' />
                            <span>{navigationItemLabel}</span>
                          </SidebarNavigationItem>
                        }
                        onActivatorClick={this.onTaskFlyoutActivatorClick}
                        onActivatorEnter={this.onTaskFlyoutActivatorEnter}
                        onActiveChange={this.onTaskFlyoutActiveChange}
                      >
                        <SidebarTask
                          active={taskFlyoutActive}
                          onClose={this.onTaskFlyoutClose}
                        />
                      </SidebarNavigationFlyout>
                      break
                    case NavigationMenuItemPage.CONTACTS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.CONTACT) && <SidebarNavigationFlyout
                        active={contactFlyoutActive}
                        activator={
                          <SidebarNavigationItem
                            to={ERoute.PATH_CONTACTS}
                            className='is-contact'
                            activeClassName='is-active'
                          >
                            <Icon icon='user' style={{ height: 18 }} />
                            <span>{navigationItemLabel}</span>
                            <SidebarNavigationItemDropdownIndicator />
                          </SidebarNavigationItem>
                        }
                        onActivatorClick={this.onContactFlyoutActivatorClick}
                        onActivatorEnter={this.onContactFlyoutActivatorEnter}
                        onActiveChange={this.onContactFlyoutActiveChange}
                      >
                        <SidebarContacts
                          active={contactFlyoutActive}
                          onClose={this.onContactFlyoutClose}
                        />
                      </SidebarNavigationFlyout>
                      break
                    case NavigationMenuItemPage.SEQUENCES:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SEQUENCE) && <div>
                        <SidebarNavigationItem to={ERoute.PATH_SEQUENCES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='paper-plane' />
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>
                      </div>
                      break
                    case NavigationMenuItemPage.DEALS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.DEAL) && <>
                        <SidebarNavigationItem to={ERoute.PATH_DEALS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='check-circle' />
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.PROJECTS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PROJECT) && <>
                        <SidebarNavigationItem to={ERoute.PATH_PROJECTS} className='is-project' activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g id="Integrations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g fill="#FFFFFF" fillRule="nonzero">
                                <path d="M10,9.5 C10,9.77625 9.77625,10 9.5,10 L6.5,10 C6.22375,10 6,9.77625 6,9.5 L6,8 L0,8 L0,12.5 C0,13.3 0.7,14 1.5,14 L14.5,14 C15.3,14 16,13.3 16,12.5 L16,8 L10,8 L10,9.5 Z" id="Path"></path>
                                <g id="Group-5" fillOpacity="0.6">
                                  <path d="M14.5,3 C15.3,3 16,3.7 16,4.5 L16,7 L0,7 L0,4.5 C0,3.7 0.7,3 1.5,3 L4,3 L4,1.5 C4,0.7 4.7,0 5.5,0 L10.5,0 C11.3,0 12,0.7 12,1.5 L12,3 L14.5,3 Z M10,3 L10,2 L6,2 L6,3 L10,3 Z" id="Combined-Shape"></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>

                        <SidebarNavigationSubItems>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_PROJECTS_PROPOSAL} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {ProjectHelper.getStatusTitle(ProjectStatus.PROPOSAL)}
                            </SidebarNavigationSubItem>
                          </li>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_PROJECTS_ON_HOLD} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {ProjectHelper.getStatusTitle(ProjectStatus.ON_HOLD)}
                            </SidebarNavigationSubItem>
                          </li>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_PROJECTS_ACTIVE} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {ProjectHelper.getStatusTitle(ProjectStatus.ACTIVE)}
                            </SidebarNavigationSubItem>
                          </li>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_PROJECTS_COMPLETED} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {ProjectHelper.getStatusTitle(ProjectStatus.COMPLETED)}
                            </SidebarNavigationSubItem>
                          </li>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_PROJECTS_CANCELLED} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {ProjectHelper.getStatusTitle(ProjectStatus.CANCELLED)}
                            </SidebarNavigationSubItem>
                          </li>
                        </SidebarNavigationSubItems>
                      </>
                      break
                    case NavigationMenuItemPage.TIME_TRACKING:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.TIME_TRACKING) && <>
                        <SidebarNavigationItem to={ERoute.PATH_TIMESHEETS} className='is-stopwatch' activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <i className='fas fa-stopwatch'></i>
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>

                        <SidebarNavigationSubItems>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_TIMESHEETS_OVERVIEW} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Overview')}
                            </SidebarNavigationSubItem>
                          </li>
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.REPORTING) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_TIMESHEETS_REPORTING} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Reporting')}
                            </SidebarNavigationSubItem>
                          </li>}
                        </SidebarNavigationSubItems>
                      </>
                      break
                    case NavigationMenuItemPage.PROPOSALS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PROPOSAL) && <>
                        <SidebarNavigationItem to={ERoute.PATH_PROPOSALS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='proposal' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.INVOICES:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && <>
                        <SidebarNavigationItem to={ERoute.PATH_ORDERS} className='is-invoice' activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <svg width="16px" height="21px" viewBox="0 0 16 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g id="App" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="Artboard" transform="translate(-327.000000, -282.000000)" fill="#FFFFFF" fillRule="nonzero">
                                <g id="file-invoice-dollar-solid" transform="translate(327.000000, 282.000000)">
                                  <path d="M9.33333333,5.578125 L9.33333333,0 L1,0 C0.445833333,0 0,0.438867187 0,0.984375 L0,20.015625 C0,20.5611328 0.445833333,21 1,21 L15,21 C15.5541667,21 16,20.5611328 16,20.015625 L16,6.5625 L10.3333333,6.5625 C9.78333333,6.5625 9.33333333,6.11953125 9.33333333,5.578125 Z M8.66666667,17.0575781 L8.66666667,18.046875 C8.66666667,18.2281641 8.5175,18.375 8.33333333,18.375 L7.66666667,18.375 C7.4825,18.375 7.33333333,18.2281641 7.33333333,18.046875 L7.33333333,17.0506055 C6.86291667,17.0268164 6.40541667,16.8652148 6.02625,16.5850781 C5.86375,16.4649023 5.85541667,16.2253711 6.0025,16.0871484 L6.49208333,15.6273633 C6.6075,15.519082 6.77916667,15.5141602 6.91416667,15.5974219 C7.07541667,15.6966797 7.25833333,15.75 7.44833333,15.75 L8.61958333,15.75 C8.89041667,15.75 9.11125,15.5071875 9.11125,15.2090039 C9.11125,14.9649609 8.96083333,14.7500391 8.74583333,14.686875 L6.87083333,14.1331641 C6.09625,13.9042969 5.555,13.1725781 5.555,12.3534961 C5.555,11.347793 6.34875,10.5307617 7.33291667,10.5049219 L7.33291667,9.515625 C7.33291667,9.33433594 7.48208333,9.1875 7.66625,9.1875 L8.33291667,9.1875 C8.51708333,9.1875 8.66625,9.33433594 8.66625,9.515625 L8.66625,10.5118945 C9.13666667,10.5356836 9.59416667,10.696875 9.97333333,10.9774219 C10.1358333,11.0975977 10.1441667,11.3371289 9.99708333,11.4753516 L9.5075,11.9351367 C9.39208333,12.043418 9.22041667,12.0483398 9.08541667,11.9650781 C8.92416667,11.8654102 8.74125,11.8125 8.55125,11.8125 L7.38,11.8125 C7.10916667,11.8125 6.88833333,12.0553125 6.88833333,12.3534961 C6.88833333,12.5975391 7.03875,12.8124609 7.25375,12.875625 L9.12875,13.4293359 C9.90333333,13.6582031 10.4445833,14.3899219 10.4445833,15.2090039 C10.4445833,16.2151172 9.65083333,17.0317383 8.66666667,17.0575781 Z M2.66666667,2.953125 C2.66666667,2.77183594 2.81583333,2.625 3,2.625 L6.33333333,2.625 C6.5175,2.625 6.66666667,2.77183594 6.66666667,2.953125 L6.66666667,3.609375 C6.66666667,3.79066406 6.5175,3.9375 6.33333333,3.9375 L3,3.9375 C2.81583333,3.9375 2.66666667,3.79066406 2.66666667,3.609375 L2.66666667,2.953125 Z M2.66666667,6.234375 L2.66666667,5.578125 C2.66666667,5.39683594 2.81583333,5.25 3,5.25 L6.33333333,5.25 C6.5175,5.25 6.66666667,5.39683594 6.66666667,5.578125 L6.66666667,6.234375 C6.66666667,6.41566406 6.5175,6.5625 6.33333333,6.5625 L3,6.5625 C2.81583333,6.5625 2.66666667,6.41566406 2.66666667,6.234375 Z" id="Shape"></path>
                                  <path d="M15.7083333,4.30664062 L11.6291667,0.287109375 C11.4416667,0.102539062 11.1875,0 10.9208333,0 L10.6666667,0 L10.6666667,5.25 L16,5.25 L16,4.99980469 C16,4.74140625 15.8958333,4.49121094 15.7083333,4.30664062 Z" id="Path-2" fillOpacity="0.6"></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>

                        <SidebarNavigationSubItems>
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && setting.order_forms_enabled && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_ORDER_FORMS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Order forms')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && setting.delivery_notes_enabled && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_DELIVERY_NOTES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Delivery notes')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_QUOTATIONS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Quotations')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && setting.pro_forma_invoices_enabled && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_PRO_FORMA_INVOICES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Proforma invoices')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_INVOICES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Invoices')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_CREDIT_NOTES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Credit notes')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INVOICE) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_RECURRING_INVOICES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Recurring invoices')}
                            </SidebarNavigationSubItem>
                          </li>}
                        </SidebarNavigationSubItems>
                      </>
                      break
                    case NavigationMenuItemPage.CONTRACTS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.CONTRACT) && <>
                        <SidebarNavigationItem to={ERoute.PATH_CONTRACTS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='file-contract' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.EXPENSES:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.EXPENSE) && <>
                        <SidebarNavigationItem to={ERoute.PATH_EXPENSES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='receipt' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.BANK:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.BANK) && <>
                        <SidebarNavigationItem to={ERoute.PATH_BANK} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='bank' />
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>

                        <SidebarNavigationSubItems>
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.BANK) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_BANK_ACCOUNTS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Accounts')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.BANK) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_BANK_TRANSACTIONS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Transactions')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.BANK_PAYMENT) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_BANK_PAYMENTS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Payments')}
                            </SidebarNavigationSubItem>
                          </li>}
                        </SidebarNavigationSubItems>
                      </>
                      break
                    case NavigationMenuItemPage.PRODUCTS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PRODUCT) && <>
                        <SidebarNavigationItem to={ERoute.PATH_PRODUCTS} className='is-product' activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g id="Integrations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="box-solid" fill="#FFFFFF" fillRule="nonzero">
                                <path d="M15.921875,5.76875 L14.340625,1.025 C14.1375,0.4125 13.565625,0 12.91875,0 L8.5,0 L8.5,6 L15.959375,6 C15.946875,5.921875 15.946875,5.84375 15.921875,5.76875 Z" id="Path" fillOpacity="0.6"></path>
                                <path d="M7.5,0 L3.08125,0 C2.434375,0 1.8625,0.4125 1.659375,1.025 L0.078125,5.76875 C0.053125,5.84375 0.053125,5.921875 0.040625,6 L7.5,6 L7.5,0 Z" id="Path" fillOpacity="0.6"></path>
                                <path d="M0,7 L0,14.5 C0,15.328125 0.671875,16 1.5,16 L14.5,16 C15.328125,16 16,15.328125 16,14.5 L16,7 L0,7 Z" id="Path"></path>
                              </g>
                            </g>
                          </svg>
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.SCHEDULING:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.BOOKING) && <>
                        <SidebarNavigationItem to={ERoute.PATH_SCHEDULING} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='calendar-clock' />
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>

                        <SidebarNavigationSubItems>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_SCHEDULING_EVENT_TYPES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Event types')}
                            </SidebarNavigationSubItem>
                          </li>
                          <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_SCHEDULING_BOOKINGS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Bookings')}
                            </SidebarNavigationSubItem>
                          </li>
                        </SidebarNavigationSubItems>
                      </>
                      break
                    case NavigationMenuItemPage.FORMS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.FORM) && <>
                        <SidebarNavigationItem to={ERoute.PATH_FORMS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='input-pipe' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.FILES:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.FILE) && <>
                        <SidebarNavigationItem to={ERoute.PATH_FILES} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='folder' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.REPORTING:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.REPORTING) && <>
                        <SidebarNavigationItem to={ERoute.PATH_REPORTING} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g id="Integrations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="reports" fill="#FFFFFF">
                                <path d="M16.2857143,2.5 L16.2857143,7.26902668 L11.9220779,7.26902668 C11.7032818,7.26906827 11.4982329,7.36737803 11.3613275,7.53318731 L11.2988052,7.62157447 L9.87116883,10 L7.50680519,4.09173512 C7.40433373,3.83523222 7.16527403,3.6589327 6.88983266,3.63673596 C6.64882146,3.61731381 6.41639286,3.71881295 6.26674592,3.90311574 L6.2078961,3.98706113 L4.23771429,7.26902668 L0.285714286,7.26902668 L0.285714286,2.5 C0.285714286,1.11928813 1.40500241,2.53632657e-16 2.78571429,0 L13.7857143,0 C15.1664262,-1.47995115e-15 16.2857143,1.11928813 16.2857143,2.5 Z" id="Path" fillOpacity="0.6"></path>
                                <path d="M0.285714286,13.5 L0.285714286,8.73097332 L4.64935065,8.73097332 C4.86814675,8.73093173 5.07319563,8.63262197 5.2101011,8.46681269 L5.27262338,8.37842553 L6.70025974,6 L9.06462338,11.9104456 C9.15434161,12.1350283 9.34876191,12.2981168 9.58061609,12.3501369 L9.68207792,12.3654867 L9.74025974,12.3654867 C9.95905584,12.3654451 10.1641047,12.2671353 10.3010102,12.101326 L10.3635325,12.0129389 L12.3337143,8.73097332 L16.2857143,8.73097332 L16.2857143,13.5 C16.2857143,14.8807119 15.1664262,16 13.7857143,16 L2.78571429,16 C1.40500241,16 0.285714286,14.8807119 0.285714286,13.5 Z" id="Path"></path>
                              </g>
                            </g>
                          </svg>
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.ACCOUNTANT:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.ACCOUNTANT) && <>
                        <SidebarNavigationItem to={ERoute.PATH_ACCOUNTANT} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='accountant' />
                          <span>{navigationItemLabel}</span>
                          <SidebarNavigationItemDropdownIndicator />
                        </SidebarNavigationItem>

                        <SidebarNavigationSubItems>
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.ACCOUNTANT) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_ACCOUNTANT_SEND} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Send')}
                            </SidebarNavigationSubItem>
                          </li>}
                          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.DOCUMENT) && <li>
                            <SidebarNavigationSubItem to={ERoute.PATH_ACCOUNTANT_DOCUMENTS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                              {t('MainNavigation::Documents')}
                            </SidebarNavigationSubItem>
                          </li>}
                        </SidebarNavigationSubItems>
                      </>
                      break
                    case NavigationMenuItemPage.INBOX:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.INBOX) && <>
                        <SidebarNavigationItem to={ERoute.PATH_INBOX} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='inbox' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.WIDGETS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.WIDGET) && <>
                        <SidebarNavigationItem to={ERoute.PATH_WIDGETS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='messenger-conversations-active' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.HELP_CENTERS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.HELP_CENTER) && <>
                        <SidebarNavigationItem to={ERoute.PATH_HELP_CENTERS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='book' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    case NavigationMenuItemPage.NEWS_CENTERS:
                      navigationItem = UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.NEWS_CENTER) && <>
                        <SidebarNavigationItem to={ERoute.PATH_NEWS_CENTERS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                          <Icon icon='bullhorn' />
                          <span>{navigationItemLabel}</span>
                        </SidebarNavigationItem>
                      </>
                      break
                    default: navigationItem = null
                  }

                  return (
                    <li key={index}>
                      {navigationItem}
                    </li>
                  )
                } else if (navigationMenuItem.type === NavigationMenuItemType.GROUP) {
                  return (
                    <li key={index}>
                      <SidebarGroupNavigationItem
                        item={navigationMenuItem}
                      />
                    </li>
                  )
                } else if (navigationMenuItem.type === NavigationMenuItemType.LINK) {
                  const internalLink = navigationMenuItem.value.startsWith(window.location.origin) || navigationMenuItem.value.startsWith('/')
                  return (
                    <li key={index}>
                      <SidebarNavigationItemLink href={navigationMenuItem.value} target={internalLink ? '_self' : '_blank'}>
                        <Icon icon='link' />
                        <span>{navigationMenuItem.label}</span>
                      </SidebarNavigationItemLink>
                    </li>
                  )
                } else if (navigationMenuItem.type === NavigationMenuItemType.DIVIDER) {
                  return (
                    <SidebarNavigationItemDivider />
                  )
                }
              })}
            </SidebarNavigationGroup>


            <SidebarNavigationGroup style={{ marginBottom: 4 }}>
              {UserWorkspaceSettingHelper.hasRole(UserWorkspaceSettingRole.OWNER) && <SidebarNavigationItem to={ERoute.PATH_INTEGRATIONS} activeClassName='is-active' onClick={this.closeMobileNavigation}>
                <i className='fas fa-bolt'></i>
                <span>{t('MainNavigation::Integrations')}</span>
              </SidebarNavigationItem>}

              <div style={{ position: 'relative' }}>
                <SidebarNavigationItemDiv onClick={this.onChatClick}>
                  <Icon icon='support' />
                  <span>{t('MainNavigation::Need help?')}</span>
                </SidebarNavigationItemDiv>
              </div>

              <div style={{ position: 'relative' }}>
                <SidebarNavigationItemDiv ref={this.accountFlyoutToggle} className={`${accountFlyoutActive ? 'is-active' : ''}`} onClick={this.onToggleAccountFlyout}>
                  <i className='fas fa-cog'></i>
                  <span>{t('MainNavigation::Settings')}</span>
                </SidebarNavigationItemDiv>

                <CSSTransition
                  in={accountFlyoutActive}
                  timeout={500}
                  classNames={{
                    appear: 'is-appear',
                    appearActive: 'is-appear-active',
                    appearDone: 'is-appear-active',
                    enter: 'is-entering',
                    enterActive: 'is-entering-active',
                    enterDone: 'is-entering-active',
                    exit: 'is-leaving',
                    exitDone: 'is-leaving',
                  }}
                  mountOnEnter
                  unmountOnExit
                  enter={true}
                  appear={true}
                  exit={true}
                >
                  <SidebarNavigationFlyoutWithReferral ref={this.accountFlyoutContainer}>
                    <AccountFlyout style={{ minWidth: 300 }}>
                      <FlyoutHeaderAccount>
                        <FlyoutHeaderAccountAvatar>
                          <Avatar name={currentUser.name || currentUser.email} width={60} />
                        </FlyoutHeaderAccountAvatar>

                        <FlyoutHeaderAccountTitle>
                          {currentUser.name ? currentUser.name : <Link to={ERoute.PATH_ACCOUNT_PROFILE} onClick={this.onDismissAccountFlyout}>-</Link>}
                        </FlyoutHeaderAccountTitle>


                        <FlyoutHeaderAccountDescription>
                          {currentUser.email}
                        </FlyoutHeaderAccountDescription>
                      </FlyoutHeaderAccount>

                      <FlyoutDivider />

                      <ul className='flyout-navigation flex'>
                        <li className='hide-mobile'>
                          <a href='javascript://' onClick={this.onMobileAppClick}>
                            <Icon icon='mobile-alt' />
                            {t('MainNavigation::Mobile app')}
                          </a>
                        </li>
                        <li>
                          <NavLink to={ERoute.PATH_ACCOUNT_PROFILE} activeClassName='is-active' onClick={this.onDismissAccountFlyout}>
                            <Icon icon='user' />
                            {t('MainNavigation::Profile')}
                          </NavLink>
                        </li>

                        {UserWorkspaceSettingHelper.hasRole(UserWorkspaceSettingRole.OWNER) && <li>
                          <NavLink to={ERoute.PATH_TEAM} activeClassName='is-active' onClick={this.onDismissAccountFlyout}>
                            <Icon icon='team' />
                            {t('MainNavigation::Team')}
                          </NavLink>
                        </li>}

                        {UserWorkspaceSettingHelper.hasRole(UserWorkspaceSettingRole.OWNER) && <li>
                          <NavLink to={ERoute.PATH_ACCOUNT_SUBSCRIPTION} activeClassName='is-active' onClick={this.onDismissAccountFlyout}>
                            <Icon icon='creditcard' />
                            {t('MainNavigation::Subscription')}
                          </NavLink>
                        </li>}

                        {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING) && <li>
                          <NavLink to={ERoute.PATH_SETTINGS} activeClassName='is-active' onClick={this.onDismissAccountFlyout}>
                            <i className='fas fa-cog'></i>
                            {t('MainNavigation::Settings')}
                          </NavLink>
                        </li>}
                      </ul>

                      <FlyoutDivider />

                      <ul className='flyout-navigation'>
                        <li>
                          <NavLink to={ERoute.PATH_WORKSPACES} activeClassName='is-active' onClick={this.onDismissAccountFlyout}>
                            <Icon icon='building' />
                            {t('MainNavigation::Sign in to another workspace')}
                          </NavLink>
                        </li>

                        <li>
                          <a href='javascript://' style={{ marginBottom: 15 }} onClick={this.onLogoutClick}>
                            <Icon icon='signout' /> {t('MainNavigation::Logout')}
                          </a>
                        </li>
                      </ul>
                    </AccountFlyout>
                    <FlyoutReferral>
                      <FlyoutReferralHeader>
                        {t('MainNavigation::🎉 Refer others to Bizzey 🎉')}
                      </FlyoutReferralHeader>
                      <FlyoutReferralContent>
                        <img src={Images.REFER_A_FRIEND} />
                        <p>{t('MainNavigation::We\'re a small business that relies on word of mouth from people like you. If you\'re enjoying Bizzey, please help us spread the word!')}</p>

                        <FlyoutReferralAction to={ERoute.PATH_REFER_A_FRIEND} onClick={this.onDismissAccountFlyout}>
                          {t('MainNavigation::Get 20€ credit for each new customer')}
                        </FlyoutReferralAction>
                      </FlyoutReferralContent>
                    </FlyoutReferral>
                  </SidebarNavigationFlyoutWithReferral>
                </CSSTransition>
              </div>
            </SidebarNavigationGroup>
          </SidebarContent>
        </SidebarNavigation>
      </>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser,
    },

    navigation: {
      active,
    }
  } = state

  return {
    currentUser: currentUser,
    navigationActive: active,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    showMobileAppModal: () => dispatch(showMobileAppModal()),
    closeNavigation: () => dispatch(closeNavigation())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MainNavigation))